<div class="alert alert-warning" role="alert">
    <i class="fas fa-sync-alt fa-spin"></i> Cargando información...
</div>
